import { initConfig, config } from '@finn-no/huck-config'
import { trackEvent, trackEventLater } from '@finn-no/analytics'
import rxios from 'redaxios'

const target = document.getElementById('pf-bfft-links')

;(async () => {
  try {
    if (target.dataset.config) initConfig(target)
    await render(config)
  } catch (err) {
  } finally {
    setupTracking()
  }
})()

async function render({ api }) {
  if (!api) throw "Missing data needed to client-side render pf-bfft-links"
  try {
    const res = await rxios.get(api)
    target.innerHTML = res.data
  } catch (err) {
    console.log("pf-bfft-links caught", err.response)
  }
}

function setupTracking() {
  target.addEventListener('click', track)
  const data = (document.getElementById('pf-bfft-links-rendered') || {}).dataset
  if (data && data.tracking) trackEvent({ analyticsName: data.tracking })
}

const tracking = {
  trackFinanceLinkTorget: {
    analyticsName: 'show-interest.finance-link-torget.click',
    eventFlags: 'start'
  },
  trackInsuranceLinkCar: {
    analyticsName: 'show-interest.click-insurance-integration.click',
    eventFlags: 'success'
  },
  trackFinanceLinkCar: {
    analyticsName: 'show-interest.click-finance-integration.click',
    eventFlags: 'success'
  },
  trackWarrantyLinkCar: {
    analyticsName: 'show-interest.click-warranty-integration.click',
    eventFlags: 'success'
  },
}

function track(e) {
  const el = e.target.closest('[data-pf-tracking]')
  if (el) {
    const trackingObj = tracking[el.getAttribute('data-pf-tracking') || '']
    if (trackingObj) trackEventLater(trackingObj)
  }
}

